module.exports = __webpack_public_path__ + "static/media/wave-square.f192d2df.svg";